import { RECENT_SEARCHES_KEY } from './constants';

export const getRecentSearches = () => JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY)) || [];

export const setRecentSearches = (recentSearches = []) =>
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(recentSearches));

export const clearRecentSearches = () => localStorage.removeItem(RECENT_SEARCHES_KEY);
